export default __webpack_public_path__ + "static/media/TwitterIcon.7df7f199.png";